import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { MainTitle, Spinner } from '../../../common/index.jsx';
import IngProjectsDetail from '../../../common/IngProjects/IngProjectsDetail.jsx';
import { useGetPublicIngProjectQuery } from '../../../../redux/services/ing_projects.jsx';
import useScrollToTopOnMount from '../../../../hooks/useScrollToTopOnMount.jsx';

const IngProjectsPublicDetailPage = () => {
  useScrollToTopOnMount();
  const { t } = useTranslation();
  const { projectId } = useParams();
  const { data: project, isLoading } = useGetPublicIngProjectQuery(projectId);

  useEffect(() => {
    document.title = t('Detail inžinierskeho projektu') + ' | FRI UNIZA';
  }, [t]);

  return (
    <>
      <MainTitle title={t('Detail projektu inž. štúdia')} backAction={true} />

      {isLoading || !project ? <Spinner /> : <IngProjectsDetail project={project} />}
    </>
  );
};

export default IngProjectsPublicDetailPage;
